/* BG-166: one light sweep on a top-10 BGG rank box once 60% of it is on screen. Loaded (deferred) only on
   top-10 PDPs by snippets/bgg-game-stats.liquid; CSS there plays it (and skips it under reduced motion). */
(() => {
  const els = document.querySelectorAll('.bgg-rank--t1:not(.is-shine)');
  if (!els.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting && e.intersectionRatio >= 0.6) {
        e.target.classList.add('is-shine');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.6 });
  els.forEach((el) => io.observe(el));
})();
